import { render, staticRenderFns } from "./WrongBookDialog.vue?vue&type=template&id=0a5669dc&scoped=true&"
import script from "./WrongBookDialog.vue?vue&type=script&lang=js&"
export * from "./WrongBookDialog.vue?vue&type=script&lang=js&"
import style0 from "./WrongBookDialog.vue?vue&type=style&index=0&id=0a5669dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5669dc",
  null
  
)

component.options.__file = "WrongBookDialog.vue"
export default component.exports